import { Component, OnInit } from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { ApiAnalyticsService } from 'src/app/services/api-analytics.service';
import { ApiService } from '../../services/api.service';
import { DataService } from "../../services/data.service";
import { URL_IMG} from '../../constants/general';

@Component({
  selector: 'app-beneficiary',
  templateUrl: './beneficiary.component.html',
  styleUrls: ['./beneficiary.component.scss'],
  host:{
    'class':'col forms-assisted-style d-flex justify-content-center first-beneficiary-content first-autonomous-content'
  }
})
export class BeneficiaryComponent implements OnInit {

  form: UntypedFormGroup;
  dataBeneficiary = {
    nombre:'',
    aPaterno:'',
    aMaterno:'',
    parentescoTxt:'',
    parentescoVal:'',
    parentescoID:'',
    fechaNacBnfcrDD:'',
    fechaNacBnfcrMM:'',
    fechaNacBnfcrYYYY:'',
    fechaNacimientoBnfcrDp:'',
    mismoDomicilio:'',
    tipoDomicilioVal:'',
    tipoDomicilioTxt:'',
    codigoPostal:'',
    numeroInt:'',
    numeroExt:'',
    paisVal:'',
    paisTxt:'',
    paisID:'',
    estado:'',
    estadoID:'',
    estadoVal:'',
    ciudad:'',
    ciudadTxt:'',
    ciudadID:'',
    delegacion:'',
    delegacionID:'',
    delegacionVal:'',
    colonia:'',
    coloniaID:'',
    coloniaVal:'',
    calle:'',
    porcentajeBnfcr:'100',
    tipoDomicilioRadio:'',
    tipoDomicilioSelect: ''
    
  }
  typesRelationship:any=[];
  typesAddress:any=[];
  typesAddressRadio:any=[];
  typesAddressSelect:any=[];
  countries:any=[];
  cities:any=[];
  towns:any=[];
  townsShort:any=[];
  suburbs:any=[];
  estates:any=[];
  estatesShort:any=[];  
  showAddress:boolean=true;
  msgErrorBirthDate:string='';
  url_img = URL_IMG;

  constructor(private formBuilder:UntypedFormBuilder, 
              private spinner: NgxSpinnerService,
              private router: Router,
              private api: ApiService,
              private data: DataService,
              private apiAnalytics :ApiAnalyticsService) 
  { 
    this.validateSession();    
    this.buildForm();
    this.getCatRelationship();
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.data.setStep('opciones/autonomo-beneficiario');
  }  

  validateSession(){
    if( sessionStorage.getItem('data_beneficiary') ) {     
      this.dataBeneficiary = JSON.parse( sessionStorage.getItem('data_beneficiary') );  
      console.log(this.dataBeneficiary);
    } 
  }

  private buildForm() {
    const d = new Date();
    const year = d.getFullYear();
    let validators;
    let validatorsCP;
    let validatorsNumInt;
    let validatorsNumExt;
    let validatorsStreet;
    if(this.dataBeneficiary.mismoDomicilio == 'NO') {
      this.showAddress=false;
      validators = [Validators.required];
      validatorsCP = [Validators.required, Validators.maxLength(5)];
      validatorsNumExt = [Validators.required,Validators.maxLength(50)];
      validatorsStreet = [Validators.required,Validators.maxLength(100)];
    } else {
      validators = [];
      validatorsCP = [Validators.maxLength(5)];
      validatorsNumExt = [Validators.maxLength(50)];
      validatorsStreet = [Validators.maxLength(100)];
      this.showAddress=true;
    }

    this.form = this.formBuilder.group({
      nombre: [this.dataBeneficiary.nombre, [Validators.required, Validators.maxLength(50)] ],
      aPaterno: [this.dataBeneficiary.aPaterno, [Validators.required, Validators.maxLength(50)] ],
      aMaterno: [this.dataBeneficiary.aMaterno, [Validators.required, Validators.maxLength(50)] ],
      parentescoVal: [this.dataBeneficiary.parentescoID, [Validators.required] ],
      fechaNacBnfcrDD: [this.dataBeneficiary.fechaNacBnfcrDD, [Validators.required, Validators.minLength(2), Validators.maxLength(2), Validators.min(1), Validators.max(31) ] ],
      fechaNacBnfcrMM: [this.dataBeneficiary.fechaNacBnfcrMM, [Validators.required, Validators.minLength(2), Validators.maxLength(2), Validators.min(1), Validators.max(12)] ],
      fechaNacBnfcrYYYY: [this.dataBeneficiary.fechaNacBnfcrYYYY, [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.min(1), Validators.max(year) ] ],
      mismoDomicilio: [this.dataBeneficiary.mismoDomicilio, [Validators.required] ],
      tipoDomicilioRadio: [this.dataBeneficiary.tipoDomicilioRadio, validators],
      tipoDomicilioSelect: [this.dataBeneficiary.tipoDomicilioSelect],
      codigoPostal: [this.dataBeneficiary.codigoPostal, validatorsCP ],
      numeroInt: [this.dataBeneficiary.numeroInt, [Validators.maxLength(50)] ],
      numeroExt: [this.dataBeneficiary.numeroExt, validatorsNumExt ],
      paisVal: [this.dataBeneficiary.paisID, validators],
      estado: [this.dataBeneficiary.estadoID, validators],
      ciudad: [this.dataBeneficiary.ciudadID, validators],
      delegacion: [this.dataBeneficiary.delegacionID, validators],
      colonia: [this.dataBeneficiary.coloniaID, validators],
      calle: [this.dataBeneficiary.calle, validatorsStreet]
    })
  }

  get nameInput() {
    return this.form.get('nombre');
  }

  get fSurnameInput() {
    return this.form.get('aPaterno');
  }

  get sSurnameInput() {
    return this.form.get('aMaterno');
  }

  get relationshipInput() {
    return this.form.get('parentescoVal');
  }

  get birthDayInput() {
    return this.form.get('fechaNacBnfcrDD');
  }
  
  get birthMonthInput() {
    return this.form.get('fechaNacBnfcrMM');
  }

  get birthYearInput() {
    return this.form.get('fechaNacBnfcrYYYY');
  }

  get sameAddressInput() {
    return this.form.get('mismoDomicilio');
  }

  get postalCodeInput() {
    return this.form.get('codigoPostal');
  }

  get numIntInput() {
    return this.form.get('numeroInt');
  }

  get numExtInput() {
    return this.form.get('numeroExt');
  }

  get countryInput() {
    return this.form.get('paisVal');
  }

  get estateInput() {
    return this.form.get('estado');
  }

  get cityInput() {
    return this.form.get('ciudad');
  }

  get townInput() {
    return this.form.get('delegacion');
  }

  get suburbInput() {
    return this.form.get('colonia');
  }

  get streetInput() {
    return this.form.get('calle');
  }

  get typeAddressRadio() {
    return this.form.get('tipoDomicilioRadio');
  }

  get typeAddressSelect() {
    return this.form.get('tipoDomicilioSelect');
  }

  showErrorBrithDate():boolean {
    if( (this.birthDayInput.invalid && this.birthDayInput.touched && this.birthDayInput.dirty) || (this.birthMonthInput.invalid && this.birthMonthInput.touched && this.birthMonthInput.dirty) || (this.birthYearInput.invalid && this.birthYearInput.touched && this.birthYearInput.dirty)) {
      if(this.birthDayInput.value=='' && this.birthMonthInput.value=='' && this.birthYearInput.value=='') {
        this.msgErrorBirthDate='Dato requerido';
      } else {
        this.msgErrorBirthDate='El dato ingresado es invalido.';
      }      
      return true;            
    } else {
      this.msgErrorBirthDate='';
      return false;
    }    
  }

  validateDayBirth() {
    const day = this.birthDayInput.value;
    console.log(day.length);
    if(day.length == 1) {
      this.birthDayInput.setValue('0'+day);
    }
  }

  validateMonthBirth() {
    const month = this.birthMonthInput.value;
    console.log(month.length);
    if(month.length == 1) {
      this.birthMonthInput.setValue('0'+month);
    }
  }

  showHideAddress(){
    const value = this.sameAddressInput.value;
    console.log(value);
    if(value == "SI") {
      this.showAddress=true;    
      this.clearValidatorsInputAddress();  
    } else if(value == "NO") {
      this.setValidatorsInputAddress();
      this.getCountries();
      this.showAddress=false;
    }
  }

  setValidatorsInputAddress() {

    this.typeAddressRadio.setValidators([Validators.required]);
    this.typeAddressRadio.updateValueAndValidity();

    this.postalCodeInput.setValidators([Validators.required, Validators.minLength(5), Validators.maxLength(5)]);
    this.postalCodeInput.updateValueAndValidity();

    this.numExtInput.setValidators([Validators.required]);
    this.numExtInput.updateValueAndValidity();

    this.countryInput.setValidators([Validators.required]);
    this.countryInput.updateValueAndValidity();

    this.estateInput.setValidators([Validators.required]);
    this.estateInput.updateValueAndValidity();

    this.cityInput.setValidators([Validators.required]);
    this.cityInput.updateValueAndValidity();

    this.townInput.setValidators([Validators.required]);
    this.townInput.updateValueAndValidity();

    this.suburbInput.setValidators([Validators.required]);
    this.suburbInput.updateValueAndValidity();

    this.streetInput.setValidators([Validators.required]);
    this.streetInput.updateValueAndValidity();
    
  }

  clearValidatorsInputAddress() {

    this.typeAddressRadio.setValue('');
    this.typeAddressRadio.clearValidators();
    this.typeAddressRadio.updateValueAndValidity();

    this.typeAddressSelect.setValue('');
    this.typeAddressSelect.clearValidators();
    this.typeAddressSelect.updateValueAndValidity();

    this.postalCodeInput.setValue('');
    this.postalCodeInput.clearValidators();
    this.postalCodeInput.updateValueAndValidity();

    this.numExtInput.setValue('');
    this.numExtInput.clearValidators();
    this.numExtInput.updateValueAndValidity();

    this.numIntInput.setValue('');

    this.countryInput.setValue('');
    this.countryInput.clearValidators();
    this.countryInput.updateValueAndValidity();

    this.estateInput.setValue('');
    this.estateInput.clearValidators();
    this.estateInput.updateValueAndValidity();

    this.cityInput.setValue('');
    this.cityInput.clearValidators();
    this.cityInput.updateValueAndValidity();

    this.townInput.setValue('');
    this.townInput.clearValidators();
    this.townInput.updateValueAndValidity();

    this.suburbInput.setValue('');
    this.suburbInput.clearValidators();
    this.suburbInput.updateValueAndValidity();

    this.streetInput.setValue('');
    this.streetInput.clearValidators();
    this.streetInput.updateValueAndValidity();
    
    this.resetAddress();
  }  

  resetAddress() {
    this.cities=[];
    this.towns=[];
    this.townsShort=[];
    this.estatesShort=[];
    this.suburbs=[];  
    this.estateInput.setValue('');
    this.countryInput.setValue('');
    this.dataBeneficiary.paisID='';
    this.dataBeneficiary.paisTxt='';
    this.dataBeneficiary.paisVal='';
    this.dataBeneficiary.estado='';
    this.dataBeneficiary.estadoID='';
    this.dataBeneficiary.estadoVal='';
    this.dataBeneficiary.colonia='';
    this.dataBeneficiary.coloniaID='';
    this.dataBeneficiary.coloniaVal='';

  }

  setAnotherOption() {    
    
    if(this.typeAddressSelect.value != '') {
      this.typeAddressRadio.setValue("0");    
      for (const item in this.typesAddress) {
        if(this.typesAddress[item].id == this.typeAddressSelect.value) {
          this.dataBeneficiary.tipoDomicilioVal = this.typesAddress[item].id;
          this.dataBeneficiary.tipoDomicilioTxt = this.typesAddress[item].value;
          this.dataBeneficiary.tipoDomicilioSelect = this.typeAddressSelect.value;
        }
      }  
    } else {
      this.dataBeneficiary.tipoDomicilioVal = '';
      this.dataBeneficiary.tipoDomicilioTxt = '';
      this.dataBeneficiary.tipoDomicilioSelect = '';
    }
    console.log('Tipo de Domicilio Select -----> '+this.dataBeneficiary.tipoDomicilioVal+': '+this.dataBeneficiary.tipoDomicilioTxt)
    this.typeAddressSelect.setValidators([Validators.required]);
    this.typeAddressSelect.updateValueAndValidity();
  }

  setRequiredOptions() {    
    
    switch(this.typeAddressRadio.value){
      case "0":
        this.dataBeneficiary.tipoDomicilioVal = '';
        this.dataBeneficiary.tipoDomicilioTxt = '';
        this.dataBeneficiary.tipoDomicilioRadio = '';
        this.typeAddressSelect.setValidators([Validators.required]);
        this.typeAddressSelect.updateValueAndValidity();
        break;
      default:        
        for (const item in this.typesAddress) {
          if(this.typesAddress[item].id == this.typeAddressRadio.value) {
            this.dataBeneficiary.tipoDomicilioVal = this.typesAddress[item].id;
            this.dataBeneficiary.tipoDomicilioTxt = this.typesAddress[item].value;
            this.dataBeneficiary.tipoDomicilioRadio = this.typeAddressRadio.value;
          }
        }
        this.typeAddressSelect.setValue('');
        this.typeAddressSelect.clearValidators();
        this.typeAddressSelect.updateValueAndValidity();
        break;      
    } 
    console.log('Tipo de Domicilio Radio -----> '+this.dataBeneficiary.tipoDomicilioVal+': '+this.dataBeneficiary.tipoDomicilioTxt)
  }

  setValueRelationship() {
    if(this.relationshipInput.value == '') {
      this.dataBeneficiary.parentescoVal='';
      this.dataBeneficiary.parentescoTxt='';
      this.dataBeneficiary.parentescoID='';
    } else {
      this.dataBeneficiary.parentescoTxt=this.typesRelationship[this.relationshipInput.value].value;
      this.dataBeneficiary.parentescoVal=this.typesRelationship[this.relationshipInput.value].id;
      this.dataBeneficiary.parentescoID=this.relationshipInput.value;
      
    }
    console.log('PARENTESCO -----> '+this.dataBeneficiary.parentescoID);
  }

  setValueCountry() {
    if(this.countryInput.value == '') {
      this.dataBeneficiary.paisVal='';
      this.dataBeneficiary.paisTxt='';
      this.dataBeneficiary.paisID='';
    } else {
      this.dataBeneficiary.paisVal=this.countries[this.countryInput.value].id;
      this.dataBeneficiary.paisTxt=this.countries[this.countryInput.value].value;
      this.dataBeneficiary.paisID=this.countryInput.value;
    }

    console.log('Pais -----> '+this.dataBeneficiary.paisVal+':'+this.dataBeneficiary.paisTxt);
  }

  setValueEstate() {
    if(this.estateInput.value == '') {
      this.dataBeneficiary.estado='';
      this.dataBeneficiary.estadoID='';
      this.dataBeneficiary.estadoVal='';
    } else {
      this.dataBeneficiary.estado=this.estates[this.estateInput.value].bezei;
      this.dataBeneficiary.estadoVal=this.estates[this.estateInput.value].bland;
      this.dataBeneficiary.estadoID=this.estateInput.value;
    }
    console.log('Estado -----> '+this.dataBeneficiary.estado);
  }

  setValueCity() {
    if(this.cityInput.value == '') {
      this.dataBeneficiary.ciudad='';
      this.dataBeneficiary.ciudadTxt='';
      this.dataBeneficiary.ciudadID='';
    } else {
      this.dataBeneficiary.ciudad=this.cities[this.cityInput.value].idcitie;
      this.dataBeneficiary.ciudadTxt=this.cities[this.cityInput.value].descripcion;
      this.dataBeneficiary.ciudadID=this.cityInput.value;
    }
    console.log('Pais -----> '+this.cityInput.value);
  }

  setValueTown() {
    if(this.townInput.value == '') {
      this.dataBeneficiary.delegacion='';
      this.dataBeneficiary.delegacionID='';
      this.dataBeneficiary.delegacionVal='';
    } else {
      this.dataBeneficiary.delegacion=this.towns[this.townInput.value].xlbez;
      this.dataBeneficiary.delegacionID=this.townInput.value;
      this.dataBeneficiary.delegacionVal=this.towns[this.townInput.value].idMunicipio;
    }
    console.log('Pais -----> '+this.dataBeneficiary.delegacionID+':'+this.dataBeneficiary.delegacion);
  }

  setValueSuburb() {
    if(this.suburbInput.value == '') {
      this.dataBeneficiary.colonia='';
      this.dataBeneficiary.coloniaID='';
      this.dataBeneficiary.coloniaVal='';
    } else {
      this.dataBeneficiary.colonia=this.suburbs[this.suburbInput.value].colonia;
      this.dataBeneficiary.coloniaVal=this.suburbs[this.suburbInput.value].idColonia;
      this.dataBeneficiary.coloniaID=this.suburbInput.value;
    }
    console.log('Pais -----> '+this.suburbInput.value);
  }
  
  updaPostalCode() {
    const value = this.postalCodeInput.value;
    if(value.length == 5) {
      this.getCitiesByCode(value);
    }
  }

  previous(type) {
    console.log(`Autonomo | Paso2 | Beneficiario | ${type}Regresar`);
    this.apiAnalytics.gTag(`Autonomo | Paso2 | Beneficiario | ${type}Regresar`, 'Autonomo | Paso2 | Beneficiario', 'Tres Pasos Bursanet','1');
    this.router.navigate(['/opciones/autonomo-completa-informacion']);
  }  

  /*
  *
  * SERVICIOS
  * 
  * */

  getCatRelationship() {
    this.spinner.show();
    this.api.getCatRelationship().subscribe((data: any[]) => {
      this.spinner.hide();
      let count=0;
      Object.entries(data).forEach(([key, value]) => {
        this.typesRelationship[count] = {id:key, value:value}
        count++;
      });

      this.typesRelationship.sort((a, b) => {
        if(a.value > b.value) return 1;
        if(a.value < b.value) return -1;    
        return 0;
      });
      
      if(this.dataBeneficiary.mismoDomicilio == 'NO') {
        this.getCountries();
      }

    }, error => {
      this.spinner.hide();
      console.log('Error: ', error);
    });
  }

  getCountries() {
    this.spinner.show();
    this.api.getCatCountries().subscribe((data: any[]) => {
      let count=0;
      Object.entries(data).forEach(([key, value]) => {
        this.countries[count] = {id:key, value:value}
        count++;
      });
      this.countries.sort((a, b) => {
        if(a.value > b.value) return 1;
        if(a.value < b.value) return -1;    
        return 0;
      });
      console.log( this.countries);
      this.getCatEstates();
    }, error => {
      this.spinner.hide();
      console.log('Error: ', error);
    });
  }

  getCatEstates() {
    this.spinner.show();
    this.api.getCatEstates().subscribe((data: any[]) => {
      this.estates = data;
      console.log(this.estates);
      this.getCatAddress();
    }, error => {
      this.spinner.hide();
      console.log('Error: ', error);
    });
  }

  getCatAddress() {
    this.spinner.show();
    this.api.getCatAddress().subscribe((data: any[]) => {
      this.spinner.hide();
      if(data == undefined) {
        this.typeAddressRadio.setValue("0");
        this.setRequiredOptions();
      } else {
        let count=0;
        Object.entries(data).forEach(([key, value]) => {
          this.typesAddress[count] = {id:key, value:value}
          count++;
        });
        this.reOrderTypesAddress();
      }
      
      if(this.dataBeneficiary.mismoDomicilio == 'NO') {
        this.getCitiesByCode(this.dataBeneficiary.codigoPostal);
      }
    }, error => {
      this.spinner.hide();
      this.typeAddressRadio.setValue("0");
      this.setRequiredOptions();
      console.log('Error: ', error);
    });
  }  

  reOrderTypesAddress() {
    let countRadio=0;
    let countSelect=0;
    if(this.typesAddress.length > 0) {
      Object.keys(this.typesAddress).map((key) => {
        switch(this.typesAddress[key].value){
          case 'CASA':
            this.typesAddressRadio[countRadio]=this.typesAddress[key];
            countRadio++;
            break;
          case 'OFICINA':
            this.typesAddressRadio[countRadio]=this.typesAddress[key];
            countRadio++;
            break;
          default:
            this.typesAddressSelect[countSelect]=this.typesAddress[key];
            countSelect++;
          break;
        }      
      });

      if(this.typesAddressRadio.length == 0) {
        this.typeAddressRadio.setValue("0");
        this.setRequiredOptions();
      }
    } else {
      this.typeAddressRadio.setValue("0");
      this.setRequiredOptions();
    }    
  }

  getCitiesByCode(codePostal) {
    this.spinner.show();
    let code = {
      cpToSearch:codePostal
    }
    this.api.getCitiesByCode(code).subscribe((data: any[]) => {
      if(data == null) {
        this.resetAddress();       
        this.spinner.hide();              
      } else {
        this.cities=data;
        this.getTownsByCode(code);
      }
    }, error => {
      this.spinner.hide();
      console.log('Error: ', error);
    });
  }

  getTownsByCode(code) {
    this.spinner.show();
    this.api.getTownsByCode(code).subscribe((data: any[]) => { 
      this.towns=data;     
      console.log( this.towns);
      this.getSuburbsByCode(code);
    }, error => {
      this.spinner.hide();
      console.log('Error: ', error);
    });
  }

  getSuburbsByCode(code) {
    this.spinner.show();
    this.api.getSuburbsByCode(code).subscribe((data: any[]) => {
      this.spinner.hide(); 
      this.suburbs=data;     
      console.log( this.suburbs);
      this.setIDsOptions();
    }, error => {
      this.spinner.hide();
      console.log('Error: ', error);
    });
  }

  setIDsOptions() {
    let id_pais = '';
    let id_entidad = '';
    let entidad = '';
    if(this.cities.length > 0) {
      id_pais = this.cities[0].idpais;
      id_entidad = this.cities[0].identidad;

      Object.keys(this.countries).map((key) => {
        if(this.countries[key].id == id_pais) {
          console.log(key+': '+this.countries[key].id);
          this.countryInput.setValue(key);
          this.dataBeneficiary.paisID=key;
          this.dataBeneficiary.paisVal=this.countries[key].id;
          this.dataBeneficiary.paisTxt=this.countries[key].value;
          return;
        }
      }); 
      
      Object.keys(this.estates).map((key) => {
        if(this.estates[key].bland == id_entidad) {
          console.log(key+': '+this.estates[key].bland);
          entidad = this.estates[key].bland;          
          this.dataBeneficiary.estadoID=key;
          this.dataBeneficiary.estado=this.estates[key].bezei;
          this.dataBeneficiary.estadoVal=this.estates[key].bland;
          this.estatesShort[0] = this.estates[key];
          this.estateInput.setValue(0);
          return;
        }
      }); 
      
      if(this.dataBeneficiary.ciudadID == '') {
        Object.keys(this.cities).map((key) => {        
          if(parseInt(key) == 0) {
            console.log(key)
            this.dataBeneficiary.ciudad=this.cities[key].idcitie;
            this.dataBeneficiary.ciudadTxt=this.cities[key].descripcion;
            this.dataBeneficiary.ciudadID=key;
            this.cityInput.setValue(key);
          }
        }); 
      }     

      if(this.dataBeneficiary.delegacionID == '') {
        Object.keys(this.towns).map((key) => {
          if(this.towns[key].bland == entidad) {          
            console.log(key+': '+entidad);
            this.dataBeneficiary.delegacionID=key;
            this.dataBeneficiary.delegacion=this.towns[key].xlbez;
            this.dataBeneficiary.delegacionVal=this.towns[key].idMunicipio;  
            this.townsShort[0] = this.towns[key];  
            this.townInput.setValue(0);      
            return;
          }
        });
      } 

      if(this.dataBeneficiary.coloniaID == '') {
        Object.keys(this.suburbs).map((key) => {   
          if(parseInt(key) == 0) {
            console.log(key)
            this.dataBeneficiary.colonia=this.suburbs[key].colonia;
            this.dataBeneficiary.coloniaVal=this.suburbs[key].idColonia;
            this.dataBeneficiary.coloniaID=key;
            this.suburbInput.setValue(key);
            console.log('ID COLONIA: '+this.dataBeneficiary.ciudadID);
          }
        }); 
      }    

    }
    
  }

  saveStepTwo(event:Event) {

    event.preventDefault();
    this.form.markAllAsTouched();
    console.log(this.form.valid)
    if(this.form.valid) {      
      console.log(this.form.value);

      let type = '';
      if(this.sameAddressInput.value == 'SI') {
        type ='MismoDomicilio';
      } else if(this.sameAddressInput.value == 'NO') {
        type ='OtroDomicilio';
      }
      
      console.log(` Autonomo | Paso2 | Beneficiario | ${type} | Continuar`);
      this.apiAnalytics.gTag(` Autonomo | Paso2 | Beneficiario | ${type} | Continuar`, 'Autonomo | Paso2 | Beneficiario', 'Tres Pasos Bursanet','1');

      let dataBeneficiary = this.buildDataSession();      
      console.log(dataBeneficiary);
      sessionStorage.removeItem('data_beneficiary');
      sessionStorage.setItem('data_beneficiary', JSON.stringify(dataBeneficiary) );
      this.router.navigate(['/opciones/autonomo-confirmacion']);
    }
  }

  buildDataSession() {

    this.dataBeneficiary.nombre=this.nameInput.value;
    this.dataBeneficiary.aPaterno=this.fSurnameInput.value;
    this.dataBeneficiary.aMaterno=this.sSurnameInput.value;
    this.dataBeneficiary.fechaNacBnfcrDD=this.birthDayInput.value;
    this.dataBeneficiary.fechaNacBnfcrMM=this.birthMonthInput.value;
    this.dataBeneficiary.fechaNacBnfcrYYYY=this.birthYearInput.value;
    this.dataBeneficiary.fechaNacimientoBnfcrDp=this.birthDayInput.value+'/'+this.birthMonthInput.value+'/'+this.birthYearInput.value;
    this.dataBeneficiary.tipoDomicilioRadio=this.typeAddressRadio.value;
    this.dataBeneficiary.tipoDomicilioSelect=this.typeAddressSelect.value;

    if(this.sameAddressInput.value=='NO') {      

      this.dataBeneficiary.mismoDomicilio=this.sameAddressInput.value;
      this.dataBeneficiary.tipoDomicilioVal=this.dataBeneficiary.tipoDomicilioVal;
      this.dataBeneficiary.tipoDomicilioTxt=this.dataBeneficiary.tipoDomicilioTxt;
      this.dataBeneficiary.codigoPostal=this.postalCodeInput.value;
      this.dataBeneficiary.numeroInt=this.numIntInput.value;
      this.dataBeneficiary.numeroExt=this.numExtInput.value;
      this.dataBeneficiary.calle= this.streetInput.value;
    } else {
      this.dataBeneficiary.mismoDomicilio=this.sameAddressInput.value;
      this.dataBeneficiary.tipoDomicilioVal='';
      this.dataBeneficiary.tipoDomicilioTxt='';
      this.dataBeneficiary.codigoPostal='';
      this.dataBeneficiary.numeroInt='';
      this.dataBeneficiary.numeroExt='';
      this.dataBeneficiary.paisVal='';
      this.dataBeneficiary.paisTxt='';
      this.dataBeneficiary.paisID='';
      this.dataBeneficiary.estado='';
      this.dataBeneficiary.estadoID='';
      this.dataBeneficiary.estadoVal='';
      this.dataBeneficiary.ciudad='';
      this.dataBeneficiary.ciudadTxt='';
      this.dataBeneficiary.ciudadID='';
      this.dataBeneficiary.delegacion='';
      this.dataBeneficiary.delegacionID='';
      this.dataBeneficiary.delegacionVal='';
      this.dataBeneficiary.colonia='';
      this.dataBeneficiary.coloniaID='';
      this.dataBeneficiary.calle='';
    }

    return this.dataBeneficiary;
  }

}
